import { useSelector } from 'react-redux';
import { getAccountCreationSettings } from 'utils/helpers';

const loginRegex = /\/accounts\/login/;
const accommodationRegex = /\/bookings\/accommodation*/;

const hideInFlow = [loginRegex, accommodationRegex];

const LoginStatus = () => {
  const user = useSelector((state) => state.user || {});
  const isAccountCreationEnabled = getAccountCreationSettings().enabled;
  const metaFlow = useSelector((state) => state.ui?.sealink?.metaFlow);
  const loginInstruction = useSelector(
    (state) => state.sealink?.loginInstruction
  );

  const { client_id: clientId, display_name: displayName } = user;

  return (
    <>
      {!hideInFlow.some((exp) => metaFlow.currentStep?.match(exp)) && (
        <div className="text-x-small">
          {clientId !== undefined ? (
            <>
              <p>Welcome back, {displayName}.</p>
              <p>
                Not you?{' '}
                <a href={`${ecom.craftConfig.api_prefix}/account/logout`}>
                  Logout
                </a>
                .
              </p>
            </>
          ) : (
            <>
              {loginInstruction && (
                <p className="text-xx-small">{loginInstruction}</p>
              )}
              {isAccountCreationEnabled ? (
                <>
                  <a href={`${ecom.craftConfig.api_prefix}/account/login`}>
                    Log in
                  </a>{' '}
                  or{' '}
                  <a
                    href={`${ecom.craftConfig.api_prefix}/account/create-account`}
                  >
                    create an account
                  </a>{' '}
                  for a faster checkout experience.
                </>
              ) : (
                <a href={`${ecom.craftConfig.api_prefix}/account/login`}>
                  Sign in for a faster checkout experience
                </a>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};

export default LoginStatus;
